import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { register } from "swiper/element/bundle";

import ContactPage from "./pages/ContactPage/ContactPage";
import HomePage from "./pages/HomePage/HomePage";
import PaymentsPage from "./pages/PaymentsPage/PaymentsPage";
import PortfolioByTypePage from "./pages/PortfolioByTypePage/PortfolioByTypePage";
import PrivacyPage from "./pages/PrivacyPage/PrivacyPage";
import ServicesPage from "./pages/ServicesPage/ServicesPage";
import TeamPage from "./pages/TeamPage/TeamPage";
import TermsConditionsPage from "./pages/TermsConditionsPage/TermsConditionsPage";

import "./i18n";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

export default function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/servicios" element={<ServicesPage />} />
				<Route
					exact
					path="/portafolio/:type"
					element={<PortfolioByTypePage />}
				/>
				<Route path="/equipo" element={<TeamPage />} />
				<Route path="/contacto" element={<ContactPage />} />
				<Route path="/metodos-de-pago" element={<PaymentsPage />} />
				<Route path="/politica-de-privacidad" element={<PrivacyPage />} />
				<Route
					path="/terminos-y-condiciones"
					element={<TermsConditionsPage />}
				/>
			</Routes>
		</BrowserRouter>
	);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();

register();
